import {Auth} from "@/helpers"

export default {
  onlyGuest(args, to, from, next) {
    if (Auth.isAuthenticated())
      next({name: 'index'})
    else
      next()
  },
  onlyAuth(args, to, from, next) {
    if (Auth.isAuthenticated())
      next()
    else
      next('/login?redirect=' + to.path)
  },
  onlyHelpDesk(args, to, from, next) {
    if (Auth.isHelpDesk() || Auth.isAdmin())
      next()
    else
      next({name: 'errors'})
  },
  onlyAdmin(args, to, from, next) {
    if (Auth.isAdmin())
      next()
    else
      next({name: 'errors'})
  },
}
